export default __webpack_public_path__ + "550be638c1f63f35b223ac67f41d3c1a.svg";